/* eslint-disable no-console */
/* eslint-disable max-len */
import React from 'react';
import { Box, Modal, Grid, Tooltip } from '@mui/material';
import { get } from 'lodash';
import { Rnd } from 'react-rnd';
import { closeIconBlack } from '../../shared/assets/images';
import SchematiDiagramSVG from './schematic-view-svg';

function EDISchematicView(props) {
  const { visibleEDISchematic, handleCloseEDISchematic, getEDIName, cocurrent, ediDetails } = props;
  let dilution_output = {
    'current_stack': 0,
    'voltage': '',
    'max_all_recovery': '',
    'energy_cons': '',
    'feed_flow': '',
    'feed_pressure': 0,
    'prod_flow': 0,
    'prod_pressure': '',
    'conc_bleed_flow': '',
    'electrode_bleed_flow': '',
    'max_conc_inlet_press': 0,
    'max_conc_outlet_press': 0,
    'max_electrode_bleed_press': 0,
    'Flow Configuration': 'Counter-Current'

  };
  let System_units = {};
  if (localStorage.getItem('edi-output-dict')) {
    const outputdata = get(JSON.parse(localStorage.getItem('edi-output-dict')), `EDI.${ediDetails.id}`, {});
    // eslint-disable-next-line prefer-destructuring
    dilution_output = outputdata.output_user.dilution_output;
  }
  if (localStorage.getItem('unit_set_dict')) {
    System_units = JSON.parse(localStorage.getItem('unit_set_dict'));
  };
  return (
    <Modal
      hideBackdrop
      open={visibleEDISchematic}
      onClose={handleCloseEDISchematic}
      className='splitter-modal'
    >
      <Box className=''>
        <Rnd
          default={{
            width: '70%',
            x: ((window.innerWidth / 2) - ((70 * (window.innerWidth / 100)) / 2)),
            y: ((window.innerHeight / 2) - ((90 * (window.innerHeight / 100)) / 2)),
          }}
          enableResizing={{
            bottom: false, bottomLeft: false, bottomRight: false,
            left: true, right: true,
            top: false, topLeft: false, topRight: false
          }}
          bounds='body'
          allowAnyClick
          enableUserSelectHack={false}
          resizeHandleStyles={{ 'right': { 'width': '5px' } }} // reducing width of right handle to 5px ---> kranthi
          onDragStart={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          minWidth='40%'
          cancel=".no_drag, .MuiOutlinedInput-root"
          className='edischematic-box'>
          <Grid container className='edischematic-grid-container'>
            <Grid item xs={12} className='edischematic-header-grid'>
              <div className='edischematic-grid-title rufusBld no_drag S_heading'>{`Schematic of EDI ${getEDIName()}`}</div>
              <div className='edischematic-grid-container'>
                <Tooltip title='Close'>
                  <img
                    src={closeIconBlack}
                    alt='close'
                    onClick={handleCloseEDISchematic}
                    style={{ width: '14px', padding: '11px' }}
                    className='pointer'
                  />
                </Tooltip>
              </div>
            </Grid>
            <Grid container style={{ 'margin': '16px' }}>
              {/* <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={4}><Grid item xs={12} className='ediSchematic-box'>{' '}</Grid></Grid>
                  <Grid item xs={4}>
                    <Grid item xs={12} className='ediSchematic-box M_Regular' >
                      <Grid item xs={12} >
                        <span className='no_drag'>{`Current/Stack =  ${dilution_output.current_stack.toFixed(1)} A`}</span>
                      </Grid>
                      <Grid item xs={12}>
                        <span className='no_drag'>{`Stack Voltage  =  ${dilution_output.voltage.toFixed(1)} V`}</span>
                      </Grid>
                      <Grid item xs={12}>
                        <span className='no_drag'>{`Energy Consumption = ${dilution_output.energy_cons.toFixed(2)} kWh/m3`}</span>
                      </Grid>
                      <Grid item xs={12}>
                        <span className='no_drag'>{`Maximum Recovery = ${dilution_output.max_all_recovery.toFixed(1)} %`}</span>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={4} ><Grid item xs={12} className='ediSchematic-box1'><Grid item xs={12} >
                    <span className='no_drag'>
                      {!cocurrent ?
                        ('Flow Configuration - Counter-Current') :
                        (`Flow Configuration - ${dilution_output['Flow Configuration']} `)
                      }
                    </span>
                  </Grid></Grid></Grid>
                </Grid>
              </Grid>
              <Grid container >
                <Grid item xs={4} className='ediSchematic-box left_box M_Regular'>
                  <div className='no_drag'>{`Feed Pressure = ${dilution_output.feed_pressure.toFixed(1)} ${System_units.Pressure}`}</div>
                  <div className='no_drag'>{`Feed Flow = ${dilution_output.feed_flow.toFixed(2)} ${System_units['Volume Flow']}`}</div>
                  <svg className='left_svg' xmlns="http://www.w3.org/2000/svg" width="262.837" height="20.559" viewBox="0 0 262.837 20.559">
                    <g transform="translate(0)">
                      <line x2="255.615" transform="translate(0 10.277)" fill="none" stroke="#002D62" strokeWidth="2" />
                      <path d="M-15326.48,8311.508v17.863l10.281-10.279-10.281-10.279Z" transform="translate(15579.037 -8308.813)" fill="#002D62" />
                    </g>
                  </svg>
                </Grid>
                <Grid item xs={3.8} className='ediSchematic-box ediSchematic-text img_box middle_box'><span className='no_drag'>Dilute</span></Grid>
                <Grid item xs={4} className='ediSchematic-box right_box M_Regular'>
                  <div className='no_drag'>{`Product Pressure = ${dilution_output.prod_pressure.toFixed(1)} ${System_units.Pressure}`}</div>
                  <div className='no_drag'>{`Product Flow = ${dilution_output.prod_flow.toFixed(2)} ${System_units['Volume Flow']}`}</div>
                  <svg className='rigth_svg' xmlns="http://www.w3.org/2000/svg" width="262.837" height="20.559" viewBox="0 0 262.837 20.559">
                    <g transform="translate(0)">
                      <line x2="255.615" transform="translate(0 10.277)" fill="none" stroke="#002D62" strokeWidth="2" />
                      <path d="M-15326.48,8311.508v17.863l10.281-10.279-10.281-10.279Z" transform="translate(15579.037 -8308.813)" fill="#002D62" />
                    </g>
                  </svg>
                </Grid>
              </Grid>
              <Grid container xs={12}>
                {cocurrent ? (<Grid item xs={4} className='ediSchematic-box left_box M_Regular'>
                  <div className='no_drag'>{`Max. Conc. inlet pressure = ${dilution_output.max_conc_inlet_press.toFixed(1)} ${System_units.Pressure}`}</div>
                  <svg className='left_svg' xmlns="http://www.w3.org/2000/svg" width="262.837" height="20.559" viewBox="0 0 262.837 20.559">
                    <g transform="translate(0)">
                      <line x2="255.615" transform="translate(0 10.277)" fill="none" stroke="#002D62" strokeWidth="2" />
                      <path d="M-15326.48,8311.508v17.863l10.281-10.279-10.281-10.279Z" transform="translate(15579.037 -8308.813)" fill="#002D62" />
                    </g>
                  </svg>
                </Grid>) : (
                  <Grid item xs={4} className='ediSchematic-box left_box M_Regular'>
                    <div className='no_drag'>{`Max. Conc. outlet pressure = ${dilution_output.max_conc_outlet_press.toFixed(1)} ${System_units.Pressure}`}</div>
                    <div className='no_drag'>{`Conc. Bleed flow = ${dilution_output.conc_bleed_flow.toFixed(2)} ${System_units['Volume Flow']}`}</div>
                    <svg className='left_svg' xmlns="http://www.w3.org/2000/svg" width="262.447" height="20.559" viewBox="0 0 262.447 20.559">
                      <line x1="255.226" transform="translate(7.222 10.277)" fill="none" stroke="#002D62" strokeWidth="2" />
                      <path d="M-15316.2,8311.508v17.863l-10.281-10.279,10.281-10.279Z" transform="translate(15326.48 -8308.813)" fill="#002D62" />
                    </svg>
                  </Grid>
                )}
                <Grid item xs={3.8} className='ediSchematic-box ediSchematic-text img_box middle_box'><span className='no_drag'>Concentrate</span></Grid>
                {cocurrent ? (
                  <Grid item xs={4} className='ediSchematic-box right_box M_Regular'>
                    <div className='no_drag'>{`Max. Conc. outlet pressure = ${dilution_output.max_conc_outlet_press.toFixed(1)} ${System_units.Pressure}`}</div>
                    <div className='no_drag'>{`Conc. Bleed flow = ${dilution_output.conc_bleed_flow.toFixed(2)} ${System_units['Volume Flow']}`}</div>
                    <svg className='rigth_svg' xmlns="http://www.w3.org/2000/svg" width="262.837" height="20.559" viewBox="0 0 262.837 20.559">
                      <g transform="translate(0)">
                        <line x2="255.615" transform="translate(0 10.277)" fill="none" stroke="#002D62" strokeWidth="2" />
                        <path d="M-15326.48,8311.508v17.863l10.281-10.279-10.281-10.279Z" transform="translate(15579.037 -8308.813)" fill="#002D62" />
                      </g>
                    </svg>
                  </Grid>
                ) : (<Grid item xs={4} className='ediSchematic-box right_box M_Regular'>
                  <div className='no_drag'>{`Max. Conc. inlet pressure = ${dilution_output.max_conc_inlet_press.toFixed(1)} ${System_units.Pressure}`}</div>
                  <svg className='rigth_svg' xmlns="http://www.w3.org/2000/svg" width="262.447" height="20.559" viewBox="0 0 262.447 20.559">
                    <line x1="255.226" transform="translate(7.222 10.277)" fill="none" stroke="#002D62" strokeWidth="2" />
                    <path d="M-15316.2,8311.508v17.863l-10.281-10.279,10.281-10.279Z" transform="translate(15326.48 -8308.813)" fill="#002D62" />
                  </svg>
                </Grid>)}
              </Grid>
              <Grid container xs={12}>
                <Grid item xs={4} className='ediSchematic-box'>
                  <Grid item xs={12} className='ediSchematic-box'>{' '}</Grid>
                </Grid>
                <Grid item xs={3.8} className='ediSchematic-box ediSchematic-text img_box middle_box'><span className='no_drag'>Electrode</span></Grid>
                <Grid item xs={4} className='ediSchematic-box right_box M_Regular'>
                  <div className='no_drag'>{`Max. Electrode Bleed Pressure = ${dilution_output.max_electrode_bleed_press.toFixed(1)} ${System_units.Pressure}`}</div>
                  <div className='no_drag'>{`Electrode Bleed Flow = ${dilution_output.electrode_bleed_flow.toFixed(2)} ${System_units['Volume Flow']}`}</div>
                  <svg className='rigth_svg' xmlns="http://www.w3.org/2000/svg" width="262.837" height="20.559" viewBox="0 0 262.837 20.559">
                    <g transform="translate(0)">
                      <line x2="255.615" transform="translate(0 10.277)" fill="none" stroke="#002D62" strokeWidth="2" />
                      <path d="M-15326.48,8311.508v17.863l10.281-10.279-10.281-10.279Z" transform="translate(15579.037 -8308.813)" fill="#002D62" />
                    </g>
                  </svg>
                </Grid>
              </Grid> */}
              <SchematiDiagramSVG
                visibleEDISchematic={visibleEDISchematic}
                handleCloseEDISchematic={handleCloseEDISchematic}
                getEDIName={getEDIName}
                cocurrent={cocurrent}
                ediDetails={ediDetails}
              />
            </Grid>
          </Grid>
        </Rnd>
      </Box>
    </Modal>
  );
}

export default EDISchematicView;